var _createClass = require("/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ValidationError = /*#__PURE__*/function (_Error) {
  "use strict";

  function ValidationError(message, cause) {
    var _this;
    _classCallCheck(this, ValidationError);
    _this = _callSuper(this, ValidationError, [message, cause]);
    _this.name = 'VALIDATION_ERROR';
    _this.message = message;
    _this.cause = cause;
    return _this;
  }
  _inherits(ValidationError, _Error);
  return _createClass(ValidationError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
module.exports = {
  ValidationError: ValidationError
};